import React, { useRef } from "react";

import { useEffect, useState } from "react";
import Pagination from "../../components/Table/pagination";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { ReactComponent as Edit } from "../../assets/images/svg/Edit.svg";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import Swal from "sweetalert2";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";

const Agents = () => {
  const { auth } = useAuth();
  const theadData = [
    "Sl-No",
    "Agent",
    "AgentStatus",
    "Virtual ID",
    "Vsip Password",
    "CallMode",
    "CallType",
    "Current Campaign",
    "Action",
  ];

  const [agents, setagents] = useState([]);
  const [Agents, setAgents] = useState([]);
  const axiosPrivate = UseAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [showStatusList, setShowStatusList] = useState(false);

  // -------------------------------- PAGINATION -------------------------------- //
  const Initial_pagination = {
    next: "",
    previous: "",
    count: "",
    total_pages: "",
    current_page: 1,
    page_size: 5,
  };

  const [pagination, setPagination] = useState(Initial_pagination);

  const PaginationControl = (type, number) => {
    if (type == "page") {
      if (number <= pagination.total_pages) {
        getAgents(number);
      } else {
        getAgents(1);
      }
    } else if (type == "last") {
      getAgents(pagination.total_pages);
    } else if (type == "prev") {
      if (pagination.current_page > 1) {
        getAgents(pagination.current_page - 1);
      }
    } else if (type == "next") {
      if (pagination.current_page < pagination.total_pages) {
        getAgents(pagination.current_page + 1);
      }
    } else {
      getAgents(1);
    }
  };
  // -------------------------------- END ---------------------------------------//
  const controller = new AbortController();
  let isMounted = true;

  var searchText = useRef("");
  var statusFilter = useRef("");
  var statusListFilter = useRef("");
  var sortFilter = useRef("");

  const getAgents = async (pagenumber) => {

    // const currentStatusList = Array.from(
    //     statusListFilter.current.children
    // ).map((li) => li.dataset.value);

    // console.log(currentStatusList)

    const agent_post_data = {
      user_id: auth?.user_details?.id,
      page: pagenumber,
      search:searchText.current.value,
      current_status:statusFilter.current.value,
      current_status_list:[...selectedColumns],
      sortby:sortFilter.current.value
    };
    try {
      const response = await axiosPrivate.get(
        process.env.REACT_APP_API_URL + "/contactcentre/agents/",
        { params: agent_post_data },
        {
          signal: controller.signal,
        }
      );

      console.log(response.data);
      isMounted && setagents(response.data.results);
      setAgents(response.data.results);

      setPagination((prevState) => {
        return {
          ...prevState,
          total_pages: response.data?.total_pages || 0,
          previous: response.data?.previous || null,
          next: response.data?.next || null,
          current_page: response.data?.current_page || 0,
          count: response.data?.count || 0,
          page_size: response.data?.page_size || 5,
        };
      });
    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  useEffect(() => {
    getAgents(1);

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const AgentDelete = async (agent_id, index) => {
    Swal.fire({
      title: "Are you sure to Delete?",
      text: "This Agent will be deleted from your campaign",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("=====camp data===", agents);

        setagents((current) =>
          current.filter((fruit) => fruit.id !== agent_id)
        );

        let post_data = {
          user_id: auth?.user_details?.user,
          agent_id: agent_id,
        };

        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.accessToken}`,
          },
        };

        await axios
          .post(
            process.env.REACT_APP_API_URL + "/contactcentre/delete_agent/",
            post_data,
            config
          )
          .then((res) => {
            console.log("=camp list loaded=", res.data);
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const searchAgent = (event) => {
    console.log(
      "==============++++++++++++++============",
      agents,
      "==============++++++++++++++============"
    );

    let search_text = event.target.value.toLowerCase(); // Convert search text to lowercase
    if (search_text !== "") {
      let search_data = agents.filter(
        (agent) => agent.agent_username.toLowerCase().includes(search_text) // Convert agent username to lowercase for comparison
      );

      setagents(search_data);
    } else {
      console.log("Search Empty", agents);
      setagents(Agents);
    }
  };


// const handleTextArea=(e)=>{
//   const slf = statusListFilter.current.value;
//   statusListFilter.current.value += `${statusFilter.current.value},`
//   // alert(statusListFilter.current.value);
//   array.forEach(element => {
    
//   });
// }
// const handleTextArea = (e) => {
//     const value = statusFilter.current.value;

//     if (!value) return;

//     const updateStatusListVisibility = () => {
//         setShowStatusList(
//             statusListFilter.current?.children.length > 0
//         );
//     };

//     // Prevent duplicates
//     const exists = Array.from(statusListFilter.current.children).some(
//         (li) => li.dataset.value === value
//     );

//     if (exists) return;

//     const li = document.createElement("li");
//     li.dataset.value = value;
//     li.style.cssText = `
//         display:flex;
//         align-items:center;
//         gap:8px;
//         padding:4px 10px;
//         background:#99bbff;
//         border:1px solid #000;
//         border-radius:8px;
//         color:#000;
//         list-style:none;
//     `;

//     const text = document.createElement("span");
//     text.textContent = value;

//     const close = document.createElement("span");
//     close.textContent = "✕";
//     close.style.cssText = `
//         cursor:pointer;
//         font-weight:bold;
//         padding:0 4px;
//     `;

//     close.onclick = () => {
//         // Show the option again in select
//         Array.from(statusFilter.current.options).forEach((option) => {
//             if (option.value === value) {
//                 option.hidden = false;
//             }
//         });

//         li.remove();
//         updateStatusListVisibility();
//     };

//     li.appendChild(text);
//     li.appendChild(close);

//     statusListFilter.current.appendChild(li);

//     // Hide selected option in select
//     Array.from(statusFilter.current.options).forEach((option) => {
//         if (option.value === value) {
//             option.hidden = true;
//         }
//     });

//     // Show list since we added an item
//     updateStatusListVisibility();

//     // Reset select
//     e.target.value = "";
// };


  const EXCEL_COLUMNS = [
    { key: "available", label: "available", default: false },
    { key: "incall", label: "incall", default: false },
    { key: "waiting", label: "waiting", default: false },
    { key: "break", label: "break", default: false },
    { key: "unavailable", label: "unavailable", default: false },
    { key: "login", label: "login", default: false },
    { key: "logout", label: "logout", default: false }
  ];

  const [selectedColumns, setSelectedColumns] = useState(
    () => new Set(EXCEL_COLUMNS.filter((c) => c.default).map((c) => c.key))
  );
  const [showColumnPicker, setShowColumnPicker] = useState(false);

  const toggleColumn = (key) => {
    setSelectedColumns((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const toggleAllColumns = () => {
    if (selectedColumns.size === EXCEL_COLUMNS.length) {
      setSelectedColumns(new Set());
    } else {
      setSelectedColumns(new Set(EXCEL_COLUMNS.map((c) => c.key)));
    }
  };


  return (
    <>
      <div className="flex flex-col bg-white">
        <div className="flex">
          <div className="flex justify-start p-3">
            <div className="max-[890px]:block flex justify-start">
              <div className="mr-5">
                <label htmlFor="table-search" className="sr-only">
                  Search
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-500 "
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <input
                    type="text"
                    id="table-search"
                    className="max-[680px]:w-[6.5rem] max-[890px]:pr-[1.2rem] max-[890px]:w-[8.5rem] max-[890px]:pr-[0rem] max-[1175px]:pr-1.5 max-[1175px]:w-[5.8rem] max-[1320px]:w-[12rem] max-[1560px]:w-60 w-80 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-10 p-2.5  mt-1"
                    placeholder="Search for items"
                    ref={searchText}
                  />
                </div>
              </div>
           
              <div className="relative ml-0 mb-0">
                  <button
                    className="flex items-center gap-2 bg-blue-50 border border-blue-300 text-blue-700 text-sm font-medium px-0 py-2.5 rounded-lg hover:bg-blue-100 transition mr-5 max-[680px]:w-[6.5rem] max-[680px]:pr-[0rem] max-[890px]:pr-0 max-[890px]:w-[8.5rem] max-[1175px]:w-[7rem] max-[1320px]:w-[12rem] max-[1320px]:pl-1 max-[1560px]:w-60 w-80 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-10 p-2.5 mt-1"
                    onClick={() => setShowColumnPicker((p) => !p)}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round"
                        d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7" />
                    </svg>
                    Select Agent Status
                    <span className="bg-blue-200 text-blue-800 text-xs rounded-full px-2 py-0.5">
                      {selectedColumns.size}/{EXCEL_COLUMNS.length}
                    </span>
                  </button>

                  {showColumnPicker && (
                    <div className="absolute z-20 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl p-4 w-72">
                      <div className="flex justify-between items-center mb-3">
                        <h3 className="text-sm font-semibold text-gray-700">Select Columns</h3>
                        <button
                          className="text-xs text-blue-600 hover:underline"
                          onClick={toggleAllColumns}
                        >
                          {selectedColumns.size === EXCEL_COLUMNS.length ? "Deselect All" : "Select All"}
                        </button>
                      </div>

                      <div className="flex flex-col gap-2 max-h-64 overflow-y-auto">
                        {EXCEL_COLUMNS.map((col) => (
                          <label
                            key={col.key}
                            className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 px-1 py-0.5 rounded"
                          >
                            <input
                              type="checkbox"
                              className="accent-blue-500"
                              checked={selectedColumns.has(col.key)}
                              onChange={() => toggleColumn(col.key)}
                            />
                            {col.label}
                          </label>
                        ))}
                      </div>

                      <div className="mt-3 pt-2 border-t flex justify-end">
                        <button
                          className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-4 py-1.5 rounded-lg"
                          onClick={() => setShowColumnPicker(false)}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                </div>


              {/* <div className="relative inline-block">
                <select
                    className="mr-5 max-[680px]:w-[6.5rem] max-[680px]:pr-[0rem] max-[890px]:pr-0 max-[890px]:w-[8.5rem] max-[1175px]:w-[7rem] max-[1320px]:w-[12rem] max-[1320px]:pl-1 max-[1560px]:w-60 w-80 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-10 p-2.5 mt-1 me-5"
                    ref={statusFilter}
                    onChange={handleTextArea}
                    onFocus={() => {
                        if (statusListFilter.current?.children.length > 0) {
                            setShowStatusList(true);
                        }
                    }}
                >
                    <option value="" selected disabled>Select Agent Status</option>
                    <option value={"available"}>Available</option>
                    <option value={"incall"}>Incall</option>
                    <option value={"waiting"}>Waiting</option>
                    <option value={"break"}>Break</option>
                    <option value={"unavailable"}>Unavailable</option>
                    <option value={"login"}>Login</option>
                    <option value={"logout"}>Logout</option>
                </select>

                <div
                    className={`absolute top-full left-0 mt-2 border rounded-lg bg-white ${
                        showStatusList ? "" : "hidden"
                    }`}
                >
                    <button
                        type="button"
                        onClick={() => setShowStatusList(false)}
                        className="absolute top-0 right-1 text-gray-500 hover:text-black"
                    >
                        ✕
                    </button>

                    <ul
                        ref={statusListFilter}
                        className="flex flex-row flex-wrap items-center gap-2 p-2 pr-8 text-sm"
                    />
                </div>
            </div> */}

            </div>

            <div className="max-[890px]:block flex justify-start me-auto my-1">

                  <select
                      className="max-[680px]:w-[6.5rem]  max-[680px]:pr-[0rem] max-[890px]:w-[8.5rem] max-[1175px]:pr-0 max-[1175px]:w-[8.5rem] max-[1320px]:w-[12rem] max-[1320px]:pl-1 max-[1560px]:w-60 w-80  bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-10 p-2.5  mt-0 mr-6 "
                      ref={sortFilter}
                  > 
                      <option value="">Select Agent Sort Option</option>
                      <option value={"by_name"} selected>By Agent Name</option>
                      <option value={"by_created"}>By Agent Creation Time</option>
                  </select>
              
                  <div className="mr-2">
                      <button type="button"
                          className="max-[680px]:w-[6.5rem] max-[890px]:w-[8.5rem] bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-1"
                          onClick={()=>{getAgents(1)}}
                      >
                          Search
                      </button>
                  </div>
            </div>

          </div>

          <div className="mt-3.5 ml-auto">
            <Link to="/admin/agent/create/0">
              <button
                type="button"
                className="max-[890px]:h-[5.2rem] max-[890px]:px-[0.5rem] inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-lg transition duration-150 ease-in-out mt-1"
              >
                + ADD AGENTS
              </button>
            </Link>
          </div>

        </div>

        <div className="py-2 inline-block min-w-full ">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-[#9AA7B5] text-[17px] font-karla font-[500]">
                  {theadData.map((item) => {
                    return (
                      <th
                        key={item}
                        title={item}
                        className="font-[500] pl-[2.1rem] pr-[1.5rem] text-start"
                      >
                        {item}
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {""}
                {agents ? (
                  <>
                    {agents.map((agent, index) => (
                      <tr
                        className="border-b text-[16px] font-karla text-gray-900  whitespace-nowrap"
                        key={
                          0 +
                          index +
                          (pagination?.current_page - 1) * pagination?.page_size
                        }
                      >
                        <td className="py-4 pl-[2.1rem] pr-[1.5rem]">
                          0
                          {index +
                            1 +
                            (pagination?.current_page - 1) *
                              pagination?.page_size}
                        </td>
                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.profile_name}
                          <br></br>
                          {agent.phone_number}
                        </td>

                        {agent.current_active_status === "logout" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4">
                            <span className="inline-flex items-left gap-1 rounded-full bg-yellow-50 px-2 py-1 text-xs font-semibold  text-[#fbbf24]">
                              <span className="h-1.5 w-1.5 rounded-full bg-[#fbbf24]"></span>
                              Logout
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4">
                            <span className="inline-flex items-left gap-1 rounded-full bg-yellow-50 px-2 py-1 text-xs font-semibold  text-[#fbbf24]">
                              {/* <span className="h-1.5 w-1.5 rounded-full bg-[#fbbf24]"></span> */}
                              {/* Logout */}
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "unavailable" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4">
                            <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-1 text-xs font-semibold text-red-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-red-600"></span>
                              Unavailable
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "break" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4">
                            <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-blue-600"></span>
                              Break
                            </span>
                          </td>
                        )}
                        {agent.current_active_status === "login" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4  text-purple-600">
                            <span className="inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-1 text-xs font-semibold text-purple-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-purple-600"></span>
                              Login
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "available" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4  text-[#26ae0b]">
                            <span className="inline-flex items-center gap-1 rounded-full bg-green-50 px-2 py-1 text-xs font-semibold text-green-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-green-600"></span>
                              Available
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "waiting" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4  text-[#26ae0b]">
                            <span className="inline-flex items-center gap-1 rounded-full bg-pink-50 px-2 py-1 text-xs font-semibold text-pink-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-pink-600"></span>
                              Waiting
                            </span>
                          </td>
                        )}

                        {agent.current_active_status === "incall" && (
                          <td className="pl-[2.1rem] pr-[1.5rem]  py-4  text-[#26ae0b]">
                            <span className="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-600">
                              <span className="h-1.5 w-1.5 rounded-full bg-orange-600"></span>
                              Incall
                            </span>
                          </td>
                        )}

                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.vsip_id || "-"}{" "}
                        </td>

                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.vsip_password || "-"}{" "}
                        </td>

                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.call_mode || "-"}{" "}
                        </td>

                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.call_options || "-"}{" "}
                        </td>

                        <td className="pl-[2.1rem] pr-[1.5rem]  py-4 ">
                          {agent.current_campaign || "-"}{" "}
                        </td>

                        <>
                          <td className="p-3 flex">
                            <div className="flex justify-between">
                              <Link to={`/admin/agent/create/${agent.id}`}>
                                <div className="flex  rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4">
                                  <Edit
                                    className={`width="26" height="26" fill="blue"`}
                                    viewBox="0 0 26 26"
                                    fill="green"
                                    cx="8.5"
                                    cy="8.5"
                                    r="6"
                                    fillRule="evenodd"
                                    fillOpacity=".8"
                                  />
                                </div>
                              </Link>
                              <div
                                onClick={() => {
                                  AgentDelete(agent.id, "stop", index);
                                }}
                                className="flex  rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4"
                              >
                                <Delete
                                  className={`width="26" height="26" fill="blue"`}
                                  viewBox="0 0 26 26"
                                  fill="red"
                                  cx="8.5"
                                  cy="8.5"
                                  r="6"
                                  fillRule="evenodd"
                                  fillOpacity=".8"
                                />
                              </div>
                            </div>
                          </td>
                        </>
                      </tr>
                    ))}
                  </>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-8">
          <Pagination
            pagination_data={pagination}
            PaginationControl={PaginationControl}
          />
        </div>
      </div>
    </>
  );
};

export default Agents;